import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import ProfileHeader from "./ProfileHeader";
import ProfileTable from "./ProfileTable";


const ProfileDetails = ({ initialProfiles, fetchEventProfiles, isApiLoading }) => {

    const [profiles, setProfiles] = useState(initialProfiles);
    const history = useHistory();

    const handleCreateProfile = () => {

    };
    const handleEdit = (profile) => {
        history.push({
            pathname: `/event-profile/${profile.profile_id}/organizer-details`,
        });
    }
    const handleClone = (profile) => {
        alert("Clone: " + profile.name);
    };
    const handleUsers = (profile) => {
        history.push({
            pathname: `/event-profile/${profile.profile_id}/team`,
        });
    };


    return (
        <>
            <div className="manage_events_container" >
                <ProfileHeader onCreate={handleCreateProfile} fetchEventProfiles={fetchEventProfiles} />
                <ProfileTable
                    profiles={profiles}
                    onEdit={handleEdit}
                    onClone={handleClone}
                    onUsers={handleUsers}
                    fetchEventProfiles={fetchEventProfiles}

                />
            </div>

            <style>{`
            
                  .manage_events_container {
                    margin: 0 !important;
                    border-radius: 0px;
                    background-color: #fff  
                    padding: "0 24px"
                
                }
            `}</style></>
    );
};

export default ProfileDetails;